import type { SituationCategory } from "@/core/fastapiClient/sdk";
import type { SortOrder, ActiveSourceType } from "@/core/fastapiClient/sdk";

// Types for the app settings to be
export type UpdateStudioTime = "immediatelly" | "onNextMount";

const appSettings = {
  // default values for the app
  default: {
    //* for Studio profile selector
    activeSituationCategory: "occupation" as SituationCategory,
    //* for origin source selector
    activeSourceType: "website" as ActiveSourceType,
    //* sort order (to thoughts, unconfirmed thoughts, etc.)
    sortOrder: "descending" as SortOrder,
    //* when to update studio if thought is confirmed
    updateStudioTime: "onNextMount" as UpdateStudioTime,
  },

  amounts: {
    charactersPerWord: 5, // average characters per word
    textTooLong: 7000, // max length of text in thought extraction
    get textTooLongWords() {
      return Math.floor(this.textTooLong / this.charactersPerWord);
    },
  },
};

export default appSettings;
